import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> into <head> for the given id and removes it on
 * unmount. Use for structured data that depends on runtime data (e.g. shows).
 */
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return undefined;
    const elId = `jsonld-${id}`;
    let el = document.getElementById(elId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(elId);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
};
